/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CustomFieldIndexPathParams, CustomFieldIndexResponse } from '../types/CustomFieldIndex'

/**
 * GET /:organisation/custom_fields
 * @see backend/nexus/modules/CustomField/Http/Controllers/CustomFieldController.php CustomFieldController::index
 */
export async function customFieldIndex(
	organisation: CustomFieldIndexPathParams['organisation'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CustomFieldIndexResponse>> {
	return axiosInstance.get(`/${organisation}/custom_fields`, config)
}
